import { InjectionKey } from 'vue';

export const DialogMode = Symbol() as InjectionKey<boolean>;